import React, { useEffect, useState } from "react";
import { transferFormData } from "../../forms/TransferForm";
import { FormTypeSelectionInput } from "../Input";
import "../../assets/styles/productServices/addProduct.scss";
import "../../assets/styles/factor/factor.scss";
import bookMarkFactorWhite from "../../assets/svg/bookMarkFactorWhite.svg";
import IconCardTransfer from "../../assets/svg/icon-card-transfer.svg";
import ArrowBottomTransfer from "../../assets/svg/arrow-bottom-transfer.svg";
import IconBuildTransfer from "../../assets/svg/IconBuildTransfer.svg";
import { useDispatch, useSelector } from "react-redux";
import { RenderFactorInputs } from "../Input/render";
import { appReset } from "../../store/actions/appAction";
import { apiGetTransfer, apiSaveTransfer, apiUpdateTransfer } from "../../api/transferApi";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate, formatPrice } from "../../helpers";
import { PageHeader } from "../Form/components";
import { apiGetBranches } from "../../api/branchApi";
import { apiGetProjects } from "../../api/projectApi";
import { apiFinancialsList } from "../../api/financialApi";
import { resetTransfer } from "../../store/actions/formAction";

export const TransferForm = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const form = transferFormData.transfer;
    const transfer = useSelector((state) => state).formReducer.transfer;
    const editItem = useSelector((state) => state.formReducer.editItem);
    const token = useSelector((state) => state).businessReducer.business?.token;

    const formTabsOrigin = transferFormData.transferOrigin;
    const formTabsDestination = transferFormData.transferDestination;
    const [originActiveTab, setOriginActiveTab] = useState(props.type ?? "bank");
    const [destinationActiveTab, setDestinationActiveTab] = useState(props.type ?? "bank");

    useEffect(() => {
        dispatch(appReset("transfer"));
        dispatch(resetTransfer());
        // updateTransfer(false);

        dispatch(apiFinancialsList("bank", token));
        dispatch(apiFinancialsList("fund", token));
        dispatch(apiFinancialsList("cashier", token));
        dispatch(apiGetProjects(token));
        dispatch(apiGetBranches(token));

        if (id) {
            dispatch(apiGetTransfer(id, token));
        }
        return ()=>{
            dispatch(appReset("transfer"));
            dispatch(resetTransfer());

        }
    }, []);

    useEffect(() => {
        updateTransfer(true);
    }, [editItem]);

    const updateTransfer = (isEdit) => {
        const transferObject = isEdit ? editItem : transfer;
        if (transferObject) {
            if (transferObject.from) {
                setOriginActiveTab(transferObject.from.type ?? originActiveTab);
            }
            if (transferObject.to) {
                setDestinationActiveTab(transferObject.to.type ?? destinationActiveTab);
            }
        }
    };
    return (
        <div className="row wrap-add-product">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {/*<div className="title-form">انتقال</div>*/}
                {/*<div className="header-transfer">ثبت انتقال بین حساب</div>*/}
                <PageHeader
                    header={{
                        backUrl: "/transfers",
                        title: "انتقال",
                        description: "ثبت انتقال بین حساب",
                        backTitle: "لیست انتقال ها",
                    }}
                    spaceLess={true}
                />
            </div>
            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 mt-4">
                <div className="row">
                    <div className="header-factor">
                        <span>انتقال</span>
                    </div>
                    <div className="body-top-factor">
                        <div className="row">
                            <RenderFactorInputs form={form.inputs} />
                        </div>
                    </div>
                    <div className="header-factor-receve">
                        <FormTypeSelectionInput
                            form={formTabsOrigin}
                            activeTab={originActiveTab}
                            setActiveTab={setOriginActiveTab}
                        />
                    </div>
                    <div className="body-top-factor">
                        <div className="row">
                            <RenderFactorInputs
                                form={formTabsOrigin?.tabs?.find((tab) => tab.key === originActiveTab)?.inputs ?? []}
                            />
                        </div>
                    </div>
                    <div className="header-factor-receve">
                        <FormTypeSelectionInput
                            form={formTabsDestination}
                            activeTab={destinationActiveTab}
                            setActiveTab={setDestinationActiveTab}
                        />
                    </div>
                    <div className="body-top-factor">
                        <div className="row">
                            <RenderFactorInputs
                                form={
                                    formTabsDestination?.tabs?.find((tab) => tab.key === destinationActiveTab)?.inputs ?? []
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            <TransferSummary id={id} originActiveTab={originActiveTab} />
        </div>
    );
};

const TransferSummary = (props) => {
    const { originActiveTab } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const form = useSelector((state) => state).formReducer;
    const transfer = useSelector((state) => state.formReducer.transfer);
    const sendingRequest = useSelector((state) => state).appReducer.sendingRequest;
    const token = useSelector((state) => state).businessReducer.business?.token;

    const submit = () => {
        if (props.id) {
            dispatch(apiUpdateTransfer(props.id, transfer, token, navigate));
        } else {
            dispatch(apiSaveTransfer(transfer, token, navigate));
        }
    };

    const [dataOrigin, setDataOrigin] = useState({});
    const [dataDestination, setDestination] = useState({});

    useEffect(() => {
        setDataOrigin(transfer.from);
        setDestination(transfer.to);
    }, [form]);
    return (
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-4">
            <div className="wrap-receipt-box">
                <h6>جزيیات انتقال</h6>
                <div className="content-receipt-box">
                    <div className="box-body-top">
                        <div className="text-code">
                            {transfer?.accountingCode && transfer?.accountingCode.length > 0
                                ? transfer?.accountingCode
                                : "اتوماتیک"}
                        </div>
                        <div>{transfer?.date ? formatDate(transfer.date) : ""}</div>
                    </div>
                    <div className="style-amount-transfer-new">
                        <b>مبلغ</b>
                    </div>
                    <div className="receipt-count-new-transfer">
                        <b>
                            {formatPrice(transfer?.amount) ?? 0} {transfer?.Currency?.fa_title ?? ""}
                        </b>
                        <div className="comotions-transfer">
                            {originActiveTab === "bank" ? (
                                <>+ {transfer?.from_wage ? formatPrice(transfer.from_wage) : null}</>
                            ) : null}
                        </div>
                    </div>
                    <div className="card-transfer-new">
                        <div className="icon-arrow-transfer">
                            <img src={ArrowBottomTransfer} alt="arrow-bottom-transfer.svg" />
                        </div>
                        <div className="item-card-transfer-new">
                            <div className="form-bank-card-box">
                                <span>از: </span>
                                <span>{dataOrigin ? dataOrigin?.accountingCode + " - " + dataOrigin?.name : null}</span>
                                <img src={IconCardTransfer} alt="IconCardTransfer" />
                            </div>
                        </div>
                        <div className="item-card-transfer-new-2">
                            <div className="form-bank-card-box">
                                <span>به: </span>
                                <span>
                                    {dataDestination ? dataDestination?.accountingCode + " - " + dataDestination?.name : null}
                                </span>
                                <img src={IconCardTransfer} alt="IconCardTransfer" />
                            </div>
                        </div>
                    </div>
                    <div className="text-build-img-transfer">
                        <img src={IconBuildTransfer} alt="IconBuildTransfer" />
                        {transfer?.Project?.title ?? "بدون پروژه"}
                    </div>
                </div>
                <div className="btns-footer-box-left-right-receipt">
                    <button
                        type="button"
                        disabled={sendingRequest}
                        className="save-and-continuation"
                        onClick={() => submit()}
                    >
                        <img src={bookMarkFactorWhite} alt="bookMarkFactorWhite" />
                        انتقال
                    </button>
                </div>
            </div>
        </div>
    );
};
